import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'
import { customMedia } from '@/styles/common/common'

const FooterWrap = styled.div`
  width: 100%;
  height: 304px;
  background: ${COLOR.gray10};
  padding-top: 63px;
  ${customMedia.lessThan('tablet')`
    padding-top: 34px;
    height: 414px;
  `}
  ${customMedia.lessThan('tablet_cut_line')`
    min-width: 328px;
    padding: 0 16px;
    height: 380px;
  `}
`

const FooterContents = styled.div`
  width: 1100px;
  margin: 0 auto;
  display: block;
  ${customMedia.lessThan('tablet')`
    max-width:600px;
    width:100%;
    margin: 0 auto;
  `}
`
const FooterTop = styled.section`
  display: flex;

  .right {
    margin-bottom: 81px;
    flex-wrap: wrap;
    width: 672px;
    display: flex;
    margin-left: 119px;

    > a {
      display: inline-block;
      width: 168px;
      height: 18px;
      line-height: 18px;
      color: ${COLOR.gray70};
      font-size: 16px;
      margin-bottom: 31px;
      font-family: NanumSquareNeoRegular, sans-serif;
      font-weight: 700;
      ${customMedia.lessThan('tablet')`
        max-width:166px;
        width:100%;
        margin: 0 auto;
        font-size: 14px;
        line-height: 15px;
     `}
    }
  }

  .left {
    > span {
      color: ${COLOR.gray40};
      font-size: 18px;
      font-family: NanumSquareNeoExtraBold, sans-serif;
    }

    > p {
      font-size: 36px;
      color: ${COLOR.black};
      font-family: NotoSansBold, sans-serif;
      margin: 14px 0 67px 0;
    }
  }

  ${customMedia.lessThan('tablet')`
    display: block;
    .right{
      margin: 0 0 31px 0;
      display: block; 
      width: 166px; 
      height: 135px;
      > a {
        width : 166px;
        padding:0;
        margin-bottom: 6px;
        font-size: 14px;
        line-height: 15px;
      }
    }
    .left{
      > span {
        display: inline-block;
        margin-top:34px;
        font-size: 14px;
        line-height: 15px;
      }
      > p {
        font-size: 24px;
        line-height: 35px;
        margin: 3px 0 22px 0;
      }
    }
  `}
`
const FooterBottom = styled.section`
  font-size: 12px;
  line-height: 17px;
  font-family: NotoSansRegular, sans-serif;
  font-weight: 400;
  color: ${COLOR.black};
  ${customMedia.lessThan('tablet')`
    font-size: 10px;
    line-height: 14px;
    margin-bottom:45px;
  `}
`

export { FooterBottom, FooterContents, FooterTop, FooterWrap }
